import normalizeComponent from "../../../_virtual/_plugin-vue2_normalizer.mjs";
const _sfc_main = {};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  return _c("svg", { attrs: { "width": "20", "height": "20", "viewBox": "0 0 20 20", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, [_c("path", { staticStyle: { "stroke": "currentcolor", "stroke-opacity": "1" }, attrs: { "d": "M10.7895 14.134V11.9614C10.7895 11.9614 8.53747 10.8221 9.51777 8.96746C10.4981 7.11282 12.6971 8.04013 12.6971 8.04013C12.6971 8.04013 12.6971 5.33771 9.9152 5.33771C7.1333 5.33771 7.1333 8.04013 7.1333 8.04013", "stroke": "currentColor", "stroke-width": "1.5" } }), _c("path", { staticStyle: { "stroke": "currentcolor", "stroke-opacity": "1" }, attrs: { "d": "M15.9135 8.17616C15.9135 8.17616 15.9135 2.48633 10.0401 2.48633C4.16666 2.48633 4.16666 8.17616 4.16666 8.17616C4.11982 8.58605 4.28684 9.72601 5.32972 11.0067C6.37259 12.2874 6.83923 12.9507 7.15941 14.0256C7.47959 15.1005 7.79977 17.5018 10.6356 17.5018C13.4715 17.5018 13.4715 14.0256 13.4715 14.0256", "stroke": "currentColor", "stroke-width": "1.5" } })]);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  null
);
const EarpieceIcon = __component__.exports;
export {
  EarpieceIcon as default
};
